import { Award, Briefcase, FileSearch, Mail, Sparkles, TrendingUp } from 'lucide-react';

import { Button } from '@/components/ui/button';

import styles from '../salary-insights.module.css';

const PROMO_FEATURES = [
  { Icon: Sparkles, label: 'Smart ATS Resume Builder' },
  { Icon: FileSearch, label: 'ATS Score Analyzer' },
  { Icon: TrendingUp, label: 'Personalized Salary Report' },
  { Icon: Award, label: 'LinkedIn Headline Generator' },
  { Icon: Mail, label: 'Custom AI Cover Letters' },
  { Icon: Briefcase, label: 'Job Description Fit Checker' },
];

export function PromoBox() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div
          className={`relative overflow-hidden rounded-3xl bg-gradient-to-br from-slate-900 via-slate-900 to-slate-800 p-8 text-white shadow-2xl shadow-slate-900/20 md:p-12 ${styles.premiumRibbon}`}
        >
          <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
            <div>
              <h2 className="mb-5 text-3xl font-extrabold leading-tight md:text-4xl lg:text-5xl">
                Command a Higher Salary with an{' '}
                <span className="text-[#3bbdad]">Optimized Resume</span>
              </h2>
              <p className="mb-8 text-lg leading-relaxed text-white/80">
                Don&apos;t apply for senior roles with a junior resume. Let our AI upgrade your
                application package instantly:
              </p>
              <div className="grid gap-x-4 gap-y-4 sm:grid-cols-2">
                {PROMO_FEATURES.map((feature) => (
                  <div key={feature.label} className="flex items-center gap-3 text-base">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#3bbdad]/15 text-[#3bbdad]">
                      <feature.Icon className="h-4 w-4" />
                    </span>
                    <span>{feature.label}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="text-center">
              <div className="rounded-3xl border border-white/10 bg-white/5 p-8 backdrop-blur-sm md:p-10">
                <p className="mb-6 text-lg text-white/90">
                  Prove you are worth the top of the range.
                </p>
                <Button
                  asChild
                  className="h-auto rounded-full bg-[#3bbdad] px-8 py-4 text-base font-extrabold text-white shadow-lg shadow-[#3bbdad]/30 transition-transform hover:-translate-y-0.5 hover:bg-[#3bbdad]/90"
                >
                  <a href="/">Optimize My Resume Now</a>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
